import { removeElement } from "../../utils/array";
var RenderingManager = /** @class */ (function () {
    function RenderingManager(pApp) {
        this.mApp = pApp;
        this.mShadowGenerators = new Array();
    }
    Object.defineProperty(RenderingManager.prototype, "shadowGenerators", {
        get: function () {
            return (this.mShadowGenerators);
        },
        enumerable: false,
        configurable: true
    });
    RenderingManager.prototype.addShadowGenerator = function (pGenerator) {
        if (pGenerator != null)
            this.mShadowGenerators.push(pGenerator);
    };
    RenderingManager.prototype.removeShadowGenerator = function (pGenerator) {
        if (pGenerator != null)
            removeElement(this.mShadowGenerators, pGenerator);
    };
    RenderingManager.prototype.notifyModelInteraction = function () {
        for (var _i = 0, _a = this.mApp.rendering.shadowGenerators; _i < _a.length; _i++) {
            var tShadowGenerator = _a[_i];
            tShadowGenerator.notifyModelInteraction();
        }
    };
    return RenderingManager;
}());
export { RenderingManager };
